import { Box } from '@bechtel/gds';
import styled from 'styled-components';

export const ImportUserRowStyled = styled(Box).attrs({
  flexDirection: { sm: 'row' },
})`
  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey[300]};
`;
